import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Tab, TabList, Tabs } from '../Tabs';

interface ILink {
  label: string;
  url: string;
}

interface IProps {
  links: ILink[];
}

const StyledTab = styled(Tab)``;

const PageNav = ({ links }: IProps) => {
  const location = useLocation();

  return (
    <Tabs>
      <TabList>
        {links.map((link, linkIndex) => (
          <StyledTab
            key={link.label}
            forwardedAs={NavLink}
            to={link.url}
            tabIndex={linkIndex}
            defaultActive={location.pathname === link.url}
          >
            {link.label}
          </StyledTab>
        ))}
      </TabList>
    </Tabs>
  );
};

export default PageNav;
